import actions from "./actions";

const initState = {
    extendedMode: false,
    taxInclusive: false,
    status: 'ready',
    myInvoisAction: 'NORMAL',
    createState: null,
    createResult: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.BATCH_INVOICING_SET_EXTENDED_MODE:
            return {
                ...state,
                extendedMode: action.extendedMode,
            };
        case actions.BATCH_INVOICING_SET_TAX_INCLUSIVE:
            return {
                ...state,
                taxInclusive: action.taxInclusive,
            };
        case actions.BATCH_INVOICING_SET_STATUS:
            return {
                ...state,
                status: action.status,
            };
        case actions.BATCH_INVOICING_SET_MYINVOIS_ACTION:
            return {
                ...state,
                myInvoisAction: action.myInvoisAction,
            };
        case actions.BATCH_INVOICING_CREATE_REQUEST:
            return {
                ...state,
                createState: 'request',
            };
        case actions.BATCH_INVOICING_CREATE_SUCCESS:
            return {
                ...state,
                createState: 'success',
                createResult: action.data,
            };
        case actions.BATCH_INVOICING_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
